import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css"; // Import the CSS file
import logo from "../../assets/images/circular_logo.jpg";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Header = () => {
  const navigate = useNavigate();

  // Check if the user is logged in
  const isLoggedIn = localStorage.getItem("token") !== null;

  const handleLogout = () => {
    localStorage.removeItem("token");
    setTimeout(() => {
      navigate(`/erp/login`);
    }, 1000);
    toast.success("Logout Successful");
  };

  return (
    <>
      <ToastContainer />
      <nav className="navbar custom-navbar">
        <Link to="/erp" className="navbar-brand">
          <img src={logo} alt="SIS Logo" />
          <h1>Shine International School, Jamudag</h1>
        </Link>

        {!isLoggedIn ? (
          <>
            <Link to="/erp/login">
              <button className="btn btn-primary">Log In</button>
            </Link>
          </>
        ) : (
          <>
            <button
              type="button"
              className="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal2"
            >
              Log Out
            </button>

            <div
              className="modal fade"
              id="exampleModal2"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel2"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel2">
                      Alert
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">Do you want to log out?</div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      onClick={handleLogout}
                      className="btn btn-danger"
                      data-bs-dismiss="modal" // Automatically closes the modal
                    >
                      Log Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </nav>
    </>
  );
};

export default Header;
